/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/skeletons/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import type { SkeletonVariant } from 'BomdisoftComponents/skeletons/render';
import type { CSSProperties } from 'react';

export type SkeletonProps = {
  variant?: SkeletonVariant;
  width?: number | string;
  height?: number | string;
  className?: string;
};

const toSize = (value?: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Skeleton = ({ variant = 'text', width, height, className }: SkeletonProps) => {
  const size: CSSProperties = {};
  const w = toSize(width);
  const h = toSize(height);
  if (w) Object.assign(size, { '--sk-w': w });
  if (h) Object.assign(size, { '--sk-h': h });
  return <span aria-hidden='true' className={joinClasses('bomdisoft-skeleton', className)} data-variant={variant} style={size} />;
};
